import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { strings } from '../../resources/strings/strings';
import { ReactComponent as Logo } from '../../resources/waspLogo.svg';
import { UserMenu } from '../user-menu/UserMenu';
import './Header.css';

export const Header = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');
  const isDesktop = useMediaQuery('(min-width:769px)');

  const logo: JSX.Element = (
    <div onClick={() => navigate('/home')} className='logo-wrapper'>
      <Logo className='wasp-logo' />
    </div>
  );

  const renderNavButtons = (): JSX.Element => {
    if (!token) {
      return (
        <>
          {isDesktop && (
            <Button
              size='small'
              variant='outlined'
              color='secondary'
              onClick={() => navigate('/partners')}
              sx={{ mr: 2 }}
            >
              {strings.res_ownersOfSpace}
            </Button>
          )}
          <Button className='login-btn-header' size='small' onClick={() => navigate('/login')} variant='text'>
            {strings.res_login}
          </Button>
          <Button
            className='register-btn-header'
            size='small'
            onClick={() => navigate('/register')}
            variant='contained'
          >
            {strings.res_register}
          </Button>
        </>
      );
    }

    return <UserMenu />;
  };

  return (
    <AppBar position='sticky' color='inherit' className='header'>
      <Container maxWidth='xl'>
        <Toolbar disableGutters={true}>
          {logo}
          <Box sx={{ flexGrow: 1 }} />
          {renderNavButtons()}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
